import SimplePeer from 'simple-peer';

export interface XMediaStreamTrackState {
  readonly muted: boolean;
  readonly live: boolean;
  readonly ended: boolean;
}

export interface XMediaStreamState {
  readonly audio: XMediaStreamTrackState | null;
  readonly video: XMediaStreamTrackState | null;
}

export type UserMediaState = 'pending' | 'rejected' | XMediaStreamState | null;

export function isUserMediaReady(state: UserMediaState) {
  if (state === null || state === 'pending' || state === 'rejected')
    return false;
  return state.audio?.live === true && state.video?.live === true;
}

/******************************************************************************/

export function getUserMedia(): Promise<MediaStream> {
  if (!SimplePeer.WEBRTC_SUPPORT)
    return Promise.reject(new Error('No support for WebRTC'));
  if (!navigator.mediaDevices)
    return Promise.reject(new Error('Cannot access media devices'));
  return navigator.mediaDevices.getUserMedia({audio: true, video: true});
}

export function mediaStreamWithoutAudio(stream: MediaStream): MediaStream {
  const result = new MediaStream();

  const videoTracks = stream.getVideoTracks();
  if (videoTracks.length > 0)
    result.addTrack(videoTracks[0]);
  return result;
}

export function disposeMediaStream(stream: MediaStream | null | undefined) {
  if (stream === null || stream === undefined)
    return;
  for (let track of stream.getTracks())
    track.stop();
  for (let track of stream.getTracks())
    stream.removeTrack(track);
}

// returns first track that is live/not stopped
export function findFirstLiveTrack(tracks: readonly MediaStreamTrack[]): MediaStreamTrack | null {
  for (let track of tracks)
    if (track.readyState === 'live')
      return track;
  return null;
}
